import moment from 'moment';
import store from '@/store';
import _ from 'lodash';

export const componentHelper = {
  i18n: function() {}
};

export const chartsHelpers = {
  getDisplaySize: function(component) {
    if (component.$vuetify.breakpoint.xs) {
      return 'xs';
    } else if (component.$vuetify.breakpoint.sm) {
      return 'sm';
    } else if (component.$vuetify.breakpoint.md) {
      return 'md';
    } else if (component.$vuetify.breakpoint.lg) {
      return 'lg';
    } else if (component.$vuetify.breakpoint.xl) {
      return 'xl';
    }
  },
  generateChartLabels: function(chart) {
    return chart.data.datasets.map(function(ds, i) {
      let meta = chart.getDatasetMeta(i);
      var arc = meta.data[i];
      let custom = (arc && arc.custom) || {};
      let fill = custom.backgroundColor ? custom.backgroundColor : ds.backgroundColor;
      let stroke = custom.borderColor ? custom.borderColor : ds.borderColor;
      let bw = custom.borderWidth ? custom.borderWidth : ds.borderWidth;

      let label = componentHelper.i18n.t(ds.label);

      if (typeof ds.labelNumberExtra !== 'undefined' && !ds.hideLabelNumberExtra) {
        label = `${label} (${ds.labelNumberExtra})`;
      }

      return {
        text: label,
        fillStyle: fill,
        strokeStyle: stroke,
        lineWidth: bw,
        hidden: meta && meta.hidden ? meta.hidden : false,
        datasetIndex: i
      };
    });
  },
  getShortFullDateXBarFormat: function() {
    return moment()
      .localeData()
      .longDateFormat('L');
  },
  getShortDateXBarFormat: function() {
    if (store.state.langSelected.lang === 'en') {
      return 'MM/DD';
    }
    return 'DD/MM';
  },
  getShortDateWithTimeXBarFormat: function() {
    if (store.state.langSelected.lang === 'en') {
      return 'MM/DD HH:mm';
    }
    return 'DD/MM HH:mm';
  },
  getPlotUnit: function(start, end) {
    let diffMonth = moment.range(start, end).diff('months');
    let diffDay = moment.range(start, end).diff('day');
    let plotUnit = diffMonth === 0 ? 'day' : 'month';
    if (diffDay < 7) {
      plotUnit = 'day';
    }
    if (diffDay <= 1) {
      plotUnit = 'minute';
    }
    return plotUnit;
  },
  getNowBar: function(start, end, nowLimit) {
    let diffMonth = moment.range(start, end).diff('months');
    if (diffMonth >= 1) {
      return [
        {
          x: moment().subtract(1, 'hours'),
          y: 0
        },
        {
          x: moment(),
          y: nowLimit
        }
      ];
    }

    let diffDay = moment.range(start, end).diff('day');
    if (diffDay <= 1) {
      return [
        {
          x: moment().subtract(3, 'minutes'),
          y: 0
        },
        {
          x: moment(),
          y: nowLimit
        }
      ];
    }

    return [
      {
        x: moment().subtract(20, 'minutes'),
        y: 0
      },
      {
        x: moment(),
        y: nowLimit
      }
    ];
  },
  fillBookingsData: function(it, yValue, start, tempBookings) {
    if (moment(it.startLocal).isBefore(moment(start))) {
      tempBookings.push({
        x: moment(start),
        y: yValue
      });
    }
    tempBookings.push({
      x: moment(it.startLocal),
      y: yValue
    });
  },
  fillGeneralViewDatasets(chartSettings, chartData, start, end, pointRadius) {
    let date = [];
    let availabilities = [];
    let dataSetsArray = [];
    let bookings = [];
    let subscriptions = [];

    let lastAvailability = -1;
    let lastBooking = 0;
    let lastSubscription = 0;

    let lastEnd = null;
    let self = this;

    _.each(chartData, function(it, index) {
      it.availability = it.availability === -1 ? 0 : it.availability;
      it.occupied = it.occupied === -1 ? 0 : it.occupied;
      if (lastAvailability !== it.availability) {
        if (moment(it.startLocal).isBefore(moment(start))) {
          availabilities.push({
            x: moment(start),
            y: it.availability
          });
          date.push(moment(start));
        } else {
          availabilities.push({
            x: moment(it.startLocal),
            y: it.availability
          });
          date.push(moment(it.startLocal));
        }
      }

      let totalBookings = it.totalAccepted + it.totalInUse + it.totalPaid;
      let totalSubscriptions = it.totalAcceptedSubscription + it.totalInUseSubscription + it.totalPaidSubscription;

      self.fillBookingsData(it, totalBookings, start, bookings);
      self.fillBookingsData(it, totalSubscriptions, start, subscriptions);

      lastBooking = totalBookings;
      lastSubscription = totalSubscriptions;

      lastAvailability = it.availability;
      lastEnd = it.endLocal;
    });

    if (lastEnd != null) {
      lastAvailability = lastAvailability === -1 ? 0 : lastAvailability;
      if (moment(lastEnd).isBefore(moment(end))) {
        availabilities.push({
          x: moment(lastEnd),
          y: lastAvailability
        });
        bookings.push({
          x: moment(lastEnd),
          y: lastBooking
        });
        subscriptions.push({
          x: moment(lastEnd),
          y: lastSubscription
        });

        date.push(moment(lastEnd));
      }
      availabilities.push({
        x: moment(end),
        y: lastAvailability
      });
      bookings.push({
        x: moment(end),
        y: lastBooking
      });
      subscriptions.push({
        x: moment(end),
        y: lastSubscription
      });

      date.push(moment(end));
    }

    let availabilitiesColor = 'rgba(139, 195, 74, 0.5)'; // green

    let bookingsColor = 'rgba(54, 198, 211,0.75)';
    let subscriptionsColor = 'rgba(255, 202, 40,0.75)';

    let countBookings = chartSettings.statusStats.countReservationsInUse + chartSettings.statusStats.countFutureReservations + chartSettings.statusStats.countReservationsPaid;

    let countSubscriptions =
      chartSettings.statusStats.countSubscriptionsPaid + chartSettings.statusStats.countFutureSubscriptions + chartSettings.statusStats.countSubscriptionsInUse;

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_incomes_legend_subscriptions',
      labelNumberExtra: countSubscriptions,
      type: 'line',
      backgroundColor: subscriptionsColor,
      borderColor: subscriptionsColor,
      hoverBackgroundColor: subscriptionsColor,
      hoverBorderColor: subscriptionsColor,
      data: subscriptions,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_incomes_legend_bookings',
      labelNumberExtra: countBookings,
      type: 'line',
      backgroundColor: bookingsColor,
      borderColor: bookingsColor,
      hoverBackgroundColor: bookingsColor,
      hoverBorderColor: bookingsColor,
      data: bookings,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'non-stacked',
      label: 'private_dash_table_availabilities_legend_bookings',
      type: 'line',
      backgroundColor: availabilitiesColor,
      borderColor: availabilitiesColor,
      hoverBackgroundColor: availabilitiesColor,
      hoverBorderColor: availabilitiesColor,
      data: availabilities,
      steppedLine: true
    });

    return {
      date: date,
      dataSetsArray: dataSetsArray
    };
  },
  fillDetailedViewDatasets(chartSettings, chartData, start, end, pointRadius) {
    let date = [];
    let availabilities = [];

    let bookingsAccepted = [];
    let bookingsInUse = [];
    let bookingsPaid = [];

    let subscriptionsAccepted = [];
    let subscriptionsInUse = [];
    let subscriptionsPaid = [];

    let dataSetsArray = [];

    let lastAvailability = -1;

    let lastAccepted = 0;
    let lastInUse = 0;
    let lastPaid = 0;

    let lastSubscriptionAccepted = 0;
    let lastSubscriptionInUse = 0;
    let lastSubscriptionPaid = 0;

    let lastEnd = null;
    let self = this;

    _.each(chartData, function(it, index) {
      it.availability = it.availability === -1 ? 0 : it.availability;
      it.occupied = it.occupied === -1 ? 0 : it.occupied;
      if (lastAvailability !== it.availability) {
        if (moment(it.startLocal).isBefore(moment(start))) {
          availabilities.push({
            x: moment(start),
            y: it.availability
          });
          date.push(moment(start));
        } else {
          availabilities.push({
            x: moment(it.startLocal),
            y: it.availability
          });
          date.push(moment(it.startLocal));
        }
      }

      self.fillBookingsData(it, it.totalAccepted, start, bookingsAccepted);
      self.fillBookingsData(it, it.totalInUse, start, bookingsInUse);
      self.fillBookingsData(it, it.totalPaid, start, bookingsPaid);
      self.fillBookingsData(it, it.totalAcceptedSubscription, start, subscriptionsAccepted);
      self.fillBookingsData(it, it.totalInUseSubscription, start, subscriptionsInUse);
      self.fillBookingsData(it, it.totalPaidSubscription, start, subscriptionsPaid);

      lastAccepted = it.totalAccepted;
      lastInUse = it.totalInUse;
      lastPaid = it.totalPaid;

      lastSubscriptionAccepted = it.totalAcceptedSubscription;
      lastSubscriptionInUse = it.totalInUseSubscription;
      lastSubscriptionPaid = it.totalPaidSubscription;

      lastAvailability = it.availability;
      lastEnd = it.endLocal;
    });

    if (lastEnd != null) {
      lastAvailability = lastAvailability === -1 ? 0 : lastAvailability;
      if (moment(lastEnd).isBefore(moment(end))) {
        availabilities.push({
          x: moment(lastEnd),
          y: lastAvailability
        });
        bookingsAccepted.push({
          x: moment(lastEnd),
          y: lastAccepted
        });
        bookingsInUse.push({
          x: moment(lastEnd),
          y: lastInUse
        });
        bookingsPaid.push({
          x: moment(lastEnd),
          y: lastPaid
        });

        subscriptionsAccepted.push({
          x: moment(lastEnd),
          y: lastSubscriptionAccepted
        });
        subscriptionsInUse.push({
          x: moment(lastEnd),
          y: lastSubscriptionInUse
        });
        subscriptionsPaid.push({
          x: moment(lastEnd),
          y: lastSubscriptionPaid
        });

        date.push(moment(lastEnd));
      }
      availabilities.push({
        x: moment(end),
        y: lastAvailability
      });

      bookingsAccepted.push({
        x: moment(end),
        y: lastAccepted
      });
      bookingsInUse.push({
        x: moment(end),
        y: lastInUse
      });
      bookingsPaid.push({
        x: moment(end),
        y: lastPaid
      });

      subscriptionsAccepted.push({
        x: moment(end),
        y: lastSubscriptionAccepted
      });
      subscriptionsInUse.push({
        x: moment(end),
        y: lastSubscriptionInUse
      });
      subscriptionsPaid.push({
        x: moment(end),
        y: lastSubscriptionPaid
      });

      date.push(moment(end));
    }

    /*
    reserva futura     purple           156,39,176
    reserva en uso     deep-purple      103,58,183
    reserva pagada     indigo           63,81,181

    abono pasado      teal              0,150,136
    abono en uso      green             76,175,80
    abono futuro      light-green       139,195,74
    */

    let availabilitiesColor = 'rgba(139, 195, 74, 0.5)'; // green

    let futureBookingsColor = 'rgba(161, 163, 166, 1)'; // gray 75%
    let bookingsInuseColor = 'rgba(240, 163, 124, 1)'; // salmon 75%
    let bookingsPaidColor = 'rgba(108, 170, 172, 1)'; // blue 75%

    let futureSubscriptionsColor = 'rgba(148, 151, 154, 1)'; // gray
    let subscriptionsInUsecolor = 'rgba(243, 152, 102, 1)'; // salmon
    let subscriptionsCompletedColor = 'rgba(65, 158, 162, 1)'; // blue

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_bookings_legend_subscriptions_in_use',
      labelNumberExtra: chartSettings.statusStats.countSubscriptionsInUse,
      type: 'line',
      backgroundColor: subscriptionsInUsecolor,
      borderColor: subscriptionsInUsecolor,
      hoverBackgroundColor: subscriptionsInUsecolor,
      hoverBorderColor: subscriptionsInUsecolor,
      data: subscriptionsInUse,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_bookings_legend_bookings_in_use',
      labelNumberExtra: chartSettings.statusStats.countReservationsInUse,
      type: 'line',
      backgroundColor: bookingsInuseColor,
      borderColor: bookingsInuseColor,
      hoverBackgroundColor: bookingsInuseColor,
      hoverBorderColor: bookingsInuseColor,
      data: bookingsInUse,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_bookings_legend_subscriptions_accepted',
      labelNumberExtra: chartSettings.statusStats.countFutureSubscriptions,
      type: 'line',
      backgroundColor: futureSubscriptionsColor,
      borderColor: futureSubscriptionsColor,
      hoverBackgroundColor: futureSubscriptionsColor,
      hoverBorderColor: futureSubscriptionsColor,
      data: subscriptionsAccepted,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_bookings_legend_bookings_accepted',
      labelNumberExtra: chartSettings.statusStats.countFutureReservations,
      type: 'line',
      backgroundColor: futureBookingsColor,
      borderColor: futureBookingsColor,
      hoverBackgroundColor: futureBookingsColor,
      hoverBorderColor: futureBookingsColor,
      data: bookingsAccepted,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_bookings_legend_subscriptions_paid',
      labelNumberExtra: chartSettings.statusStats.countSubscriptionsPaid,
      type: 'line',
      backgroundColor: subscriptionsCompletedColor,
      borderColor: subscriptionsCompletedColor,
      hoverBackgroundColor: subscriptionsCompletedColor,
      hoverBorderColor: subscriptionsCompletedColor,
      data: subscriptionsPaid,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'stacked',
      label: 'private_dash_table_bookings_legend_bookings_paid',
      labelNumberExtra: chartSettings.statusStats.countReservationsPaid,
      type: 'line',
      backgroundColor: bookingsPaidColor,
      borderColor: bookingsPaidColor,
      hoverBackgroundColor: bookingsPaidColor,
      hoverBorderColor: bookingsPaidColor,
      data: bookingsPaid,
      steppedLine: true
    });

    dataSetsArray.push({
      yAxisID: 'non-stacked',
      label: 'private_dash_table_availabilities_legend_bookings',
      type: 'line',
      backgroundColor: availabilitiesColor,
      borderColor: availabilitiesColor,
      hoverBackgroundColor: availabilitiesColor,
      hoverBorderColor: availabilitiesColor,
      data: availabilities,
      steppedLine: true
    });

    return {
      date: date,
      dataSetsArray: dataSetsArray
    };
  },
  fillChartData(chartSettings, chartData, start, end, isSensored, showGeneralView) {
    let pointRadius = 2;
    let plotUnit = chartsHelpers.getPlotUnit(start, end);
    if (_.includes(['hour', 'minute'], plotUnit)) {
      pointRadius = 3;
    }

    let result = {};

    let nowLimit = isSensored ? 1 : 100;

    let nowData = this.getNowBar(start, end, nowLimit);

    if (showGeneralView) {
      result = this.fillGeneralViewDatasets(chartSettings, chartData, start, end, pointRadius);
    } else {
      result = this.fillDetailedViewDatasets(chartSettings, chartData, start, end, pointRadius);
    }

    let nowColor = 'rgba(208, 69, 19 ,1)'; // orange

    result.dataSetsArray.unshift({
      yAxisID: 'non-stacked',
      label: 'private_availabilities_label_now',
      type: 'bar',
      backgroundColor: nowColor,
      borderColor: nowColor,
      hoverBackgroundColor: nowColor,
      hoverBorderColor: nowColor,
      lineTension: 0,
      data: nowData,
      pointRadius: pointRadius,
      pointStyle: 'rectRot',
      steppedLine: true
    });

    if (isSensored) {
      _.each(result.dataSetsArray, itDataSet => {
        itDataSet.hideLabelNumberExtra = true;
      });
    }

    return {
      date: result.date,
      dataSetsArray: result.dataSetsArray
    };
  },
  getBarOptions(component, localeIso, yTickMax) {
    componentHelper.i18n = component.$i18n;
    return {
      scaleBeginAtZero: true,
      scaleShowGridLines: true,
      scaleGridLineColor: 'rgba(0,0,0,.05)',
      scaleGridLineWidth: 1,
      barShowStroke: true,
      barStrokeWidth: 1,
      barValueSpacing: 5,
      barDatasetSpacing: 1,
      responsive: true,
      categoryPercentage: 1,
      barPercentage: 1,
      tooltips: {
        callbacks: {
          label: function(tooltipItem, chart) {
            var dataset = chart.datasets[tooltipItem.datasetIndex];
            var i18nLabel = dataset.label;
            if (i18nLabel === 'private_availabilities_label_now') {
              return '';
            }
            var value = dataset.data[tooltipItem.index];
            if (value === 0) {
              return '';
            }

            return component.$i18n.t(i18nLabel) + ': ' + Number(value).toLocaleString(localeIso) + ' (' + store.state.countryConstantsSelected.currencySymbol + ')';
          }
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          generateLabels: chartsHelpers.generateChartLabels
        },
        onHover: function(e) {
          e.target.style.cursor = 'pointer';
        }
      },
      scales: {
        yAxes: [
          {
            id: 'non-stacked',
            stacked: false,
            display: true,
            scaleLabel: {
              display: true,
              labelString: store.state.countryConstantsSelected.currencySymbol
            },
            gridLines: {
              display: true
            },
            ticks: {
              min: 0,
              beginAtZero: true,
              max: yTickMax,
              callback: function(value) {
                if (value % 1 === 0) {
                  return Number(value).toLocaleString(localeIso);
                }
              }
            }
          },
          {
            id: 'stacked',
            stacked: true,
            display: false,
            ticks: {
              min: 0,
              beginAtZero: true,
              max: yTickMax,
              callback: function(value) {
                if (value % 1 === 0) {
                  return Number(value).toLocaleString(localeIso);
                }
              }
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: true
            },
            type: 'time',
            stacked: true,
            time: {
              unit: component.plotUnit,
              tooltipFormat: chartsHelpers.getShortFullDateXBarFormat(),
              displayFormats: {
                day: chartsHelpers.getShortDateXBarFormat(),
                week: chartsHelpers.getShortDateXBarFormat(),
                minute: 'HH:mm',
                hour: chartsHelpers.getShortDateWithTimeXBarFormat()
              }
            },
            ticks: {
              min: moment(component.dates[0]),
              max: moment(component.dates[1]),
              callback: function(value, index) {
                if (component.plotUnit === 'month') {
                  return moment.months(index % 12, 'MMMM');
                }
                if (component.plotUnit === 'day') {
                  let temp = value.split(' ');
                  return temp[0];
                }
                return value;
              }
            }
          }
        ]
      }
    };
  },
  getBarBookingOptions(component, localeIso, yTickMax) {
    componentHelper.i18n = component.$i18n;
    return {
      scaleBeginAtZero: true,
      scaleShowGridLines: true,
      scaleGridLineColor: 'rgba(0,0,0,.05)',
      scaleGridLineWidth: 1,
      barShowStroke: true,
      barStrokeWidth: 1,
      barValueSpacing: 5,
      barDatasetSpacing: 1,
      responsive: true,
      categoryPercentage: 1,
      barPercentage: 1,
      tooltips: {
        callbacks: {
          label: function(tooltipItem, chart) {
            var dataset = chart.datasets[tooltipItem.datasetIndex];
            var i18nLabel = dataset.label;
            if (i18nLabel === 'private_availabilities_label_now') {
              return '';
            }
            var value = dataset.data[tooltipItem.index];
            return component.$i18n.t(i18nLabel) + ': ' + Number(value).toLocaleString(localeIso);
          }
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          generateLabels: chartsHelpers.generateChartLabels
        },
        onHover: function(e) {
          e.target.style.cursor = 'pointer';
        }
      },
      scales: {
        yAxes: [
          {
            id: 'non-stacked',
            stacked: false,
            display: true,
            scaleLabel: {
              display: true
            },
            gridLines: {
              display: true
            },
            ticks: {
              min: 0,
              beginAtZero: true,
              max: yTickMax,
              callback: function(value) {
                if (value % 1 === 0) {
                  return Number(value).toLocaleString(localeIso);
                }
              }
            }
          },
          {
            id: 'stacked',
            stacked: true,
            display: false,
            scaleLabel: {
              display: true
            },
            gridLines: {
              display: true
            },
            ticks: {
              min: 0,
              beginAtZero: true,
              max: yTickMax,
              callback: function(value) {
                if (value % 1 === 0) {
                  return Number(value).toLocaleString(localeIso);
                }
              }
            }
          }
        ],
        xAxes: [
          {
            type: 'time',
            gridLines: {
              display: true
            },
            stacked: true,
            time: {
              unit: component.plotUnit,
              tooltipFormat: chartsHelpers.getShortFullDateXBarFormat(),
              displayFormats: {
                day: chartsHelpers.getShortDateXBarFormat(),
                week: chartsHelpers.getShortDateXBarFormat(),
                minute: 'HH:mm',
                hour: chartsHelpers.getShortDateWithTimeXBarFormat()
              }
            },
            ticks: {
              min: moment(component.dates[0]),
              max: moment(component.dates[1]),
              callback: function(value, index) {
                if (component.plotUnit === 'month') {
                  return moment.months(index % 12, 'MMMM');
                }
                if (component.plotUnit === 'day') {
                  let temp = value.split(' ');
                  return temp[0];
                }
                return value;
              }
            }
          }
        ]
      }
    };
  },
  getAvailabilityParkingHomeBarOptions(component, data) {
    componentHelper.i18n = component.$i18n;
    return {
      scaleBeginAtZero: true,
      scaleShowGridLines: true,
      scaleGridLineColor: 'rgba(0,0,0,.05)',
      scaleGridLineWidth: 1,
      barShowStroke: true,
      barStrokeWidth: 1,
      barValueSpacing: 5,
      barDatasetSpacing: 1,
      responsive: true,
      categoryPercentage: 1,
      barPercentage: 1,
      tooltips: {
        position: 'nearest',
        mode: 'point',
        callbacks: {
          label: function(tooltipItem, chart) {
            var dataset = chart.datasets[tooltipItem.datasetIndex];
            var i18nLabel = dataset.label;
            if (i18nLabel === 'private_availabilities_label_now') {
              return '';
            }
            var value = dataset.data[tooltipItem.index];
            // if (value.y === 0) {
            //   return '';
            // }
            return `${component.$i18n.t(i18nLabel)}: ${value.y} (${moment(value.x).format('HH:mm')})`;
          }
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          generateLabels: chartsHelpers.generateChartLabels
        },
        onHover: function(e) {
          e.target.style.cursor = 'pointer';
        }
      },
      scales: {
        yAxes: [
          {
            id: 'non-stacked',
            stacked: false,
            display: true,
            ticks: {
              min: 0,
              max: data.chartSettings.spots,
              stepSize: data.chartSettings.spots / 10,
              beginAtZero: true,
              callback: function(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          },
          {
            id: 'stacked',
            stacked: true,
            display: false,
            ticks: {
              min: 0,
              max: data.chartSettings.spots,
              stepSize: data.chartSettings.spots / 10,
              beginAtZero: true,
              callback: function(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }
        ],
        xAxes: [
          {
            type: 'time',
            gridLines: {
              display: true
            },
            stacked: true,
            time: {
              unit: component.plotUnit,
              tooltipFormat: this.getShortFullDateXBarFormat(),
              displayFormats: {
                day: this.getShortDateXBarFormat(),
                week: this.getShortDateXBarFormat(),
                minute: 'HH:mm',
                hour: this.getShortDateWithTimeXBarFormat(),
                month: 'YYYY-MM-DD[T]00:00:00.00[Z]'
              }
            },
            ticks: {
              min: moment(component.dates[0]),
              max: moment(component.dates[1]),
              callback: function(value, index) {
                if (component.plotUnit === 'month') {
                  if (value.indexOf('T') > 0) {
                    return moment(value).format('MMMM');
                  }
                }
                if (component.plotUnit === 'day') {
                  let temp = value.split(' ');
                  return temp[0];
                }
                return value;
              }
            }
          }
        ]
      }
    };
  },
  getAvailabilityDetailsParkingSensoredBarOptions(component, showLegend, showTop) {
    componentHelper.i18n = component.$i18n;

    let legendOptions = {
      display: false
    };

    if (showLegend) {
      legendOptions.position = 'bottom';
      legendOptions.display = true;
      legendOptions.labels = {
        usePointStyle: true,
        generateLabels: chartsHelpers.generateChartLabels
      };
      legendOptions.onClick = function() {};
    }

    if (showTop) {
      legendOptions.position = 'top';
    }

    return {
      scaleBeginAtZero: true,
      scaleShowGridLines: true,
      scaleGridLineColor: 'rgba(0,0,0,.05)',
      scaleGridLineWidth: 1,
      barShowStroke: true,
      barStrokeWidth: 1,
      barValueSpacing: 5,
      barDatasetSpacing: 1,
      responsive: true,
      categoryPercentage: 1,
      barPercentage: 1,
      tooltips: {
        position: 'nearest',
        mode: 'point',
        callbacks: {
          label: function(tooltipItem, chart) {
            var dataset = chart.datasets[tooltipItem.datasetIndex];
            var i18nLabel = dataset.label;
            if (i18nLabel === 'private_availabilities_label_now') {
              return '';
            }
            var value = dataset.data[tooltipItem.index];
            // if (value.y === 0) {
            //   return '';
            // }
            return `${component.$i18n.t(i18nLabel)}: ${value.y} (${moment(value.x).format('HH:mm')})`;
          }
        }
      },
      legend: false,
      legendCallback: function(chart) {
        var legendHtml = [];
        var items = chart.data.datasets;
        for (var i = 0; i < items.length; i++) {
          legendHtml.push('<v-flex class="justify-center li">');
            legendHtml.push('<span class="chart-legend" style="background-color:' + items[i].backgroundColor + '; border: 3px solid ' + items[i].backgroundColor + ';"></span>');
            if (items[i].labelNumberExtra || items[i].labelNumberExtra === 0) {
              legendHtml.push('<span class="chart-legend-label-text">' + componentHelper.i18n.t(items[i].label) + ' (' + items[i].labelNumberExtra + ')</span>');
            } else {
              legendHtml.push('<span class="chart-legend-label-text">' + componentHelper.i18n.t(items[i].label) + '</span>');
            }
            legendHtml.push('</v-flex>');
        }

        return legendHtml.join('');
      },
      scales: {
        yAxes: [
          {
            id: 'non-stacked',
            stacked: false,
            display: true,
            ticks: {
              min: 0,
              max: 1,
              beginAtZero: true,
              callback: function(value) {
                if (value % 1 === 0) {
                  return '';
                }
              }
            }
          },
          {
            id: 'stacked',
            stacked: true,
            display: false,
            ticks: {
              min: 0,
              max: 1,
              beginAtZero: true,
              callback: function(value) {
                if (value % 1 === 0) {
                  return '';
                }
              }
            }
          }
        ],
        xAxes: [
          {
            type: 'time',
            gridLines: {
              display: true
            },
            stacked: true,
            time: {
              unit: component.plotUnit,
              tooltipFormat: this.getShortFullDateXBarFormat(),
              displayFormats: {
                day: this.getShortDateXBarFormat(),
                week: this.getShortDateXBarFormat(),
                minute: 'HH:mm',
                hour: this.getShortDateWithTimeXBarFormat(),
                month: 'YYYY-MM-DD[T]00:00:00.00[Z]'
              }
            },
            ticks: {
              min: moment(component.dates[0]),
              max: moment(component.dates[1]),
              callback: function(value, index) {
                if (component.plotUnit === 'month') {
                  if (value.indexOf('T') > 0) {
                    return moment(value).format('MMMM');
                  }
                }
                if (component.plotUnit === 'day') {
                  let temp = value.split(' ');
                  return temp[0];
                }
                return value;
              }
            }
          }
        ]
      }
    };
  },
  getAvailabilityDetailsParkingSensorlessBarOptions(component, data) {
    componentHelper.i18n = component.$i18n;
    return {
      scaleBeginAtZero: true,
      scaleShowGridLines: true,
      scaleGridLineColor: 'rgba(0,0,0,.05)',
      scaleGridLineWidth: 1,
      barShowStroke: true,
      barStrokeWidth: 1,
      barValueSpacing: 5,
      barDatasetSpacing: 1,
      responsive: true,
      categoryPercentage: 1,
      barPercentage: 1,
      tooltips: {
        position: 'nearest',
        mode: 'point',
        callbacks: {
          label: function(tooltipItem, chart) {
            var dataset = chart.datasets[tooltipItem.datasetIndex];
            var i18nLabel = dataset.label;
            if (i18nLabel === 'private_availabilities_label_now') {
              return '';
            }
            var value = dataset.data[tooltipItem.index];
            // if (value.y === 0) {
            //   return '';
            // }
            return `${component.$i18n.t(i18nLabel)}: ${value.y} (${moment(value.x).format('HH:mm')})`;
          }
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          generateLabels: chartsHelpers.generateChartLabels
        },
        onHover: function(e) {
          e.target.style.cursor = 'pointer';
        }
      },
      scales: {
        yAxes: [
          {
            id: 'non-stacked',
            stacked: false,
            display: true,
            ticks: {
              min: 0,
              max: data.chartSettings.spots,
              stepSize: data.chartSettings.spots / 10,
              beginAtZero: true,
              callback: function(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          },
          {
            id: 'stacked',
            stacked: true,
            display: false,
            ticks: {
              min: 0,
              max: data.chartSettings.spots,
              stepSize: data.chartSettings.spots / 10,
              beginAtZero: true,
              callback: function(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }
        ],
        xAxes: [
          {
            type: 'time',
            gridLines: {
              display: true
            },
            stacked: true,
            time: {
              unit: component.plotUnit,
              tooltipFormat: this.getShortFullDateXBarFormat(),
              displayFormats: {
                day: this.getShortDateXBarFormat(),
                week: this.getShortDateXBarFormat(),
                minute: 'HH:mm',
                hour: this.getShortDateWithTimeXBarFormat(),
                month: 'YYYY-MM-DD[T]00:00:00.00[Z]'
              }
            },
            ticks: {
              min: moment(component.dates[0]),
              max: moment(component.dates[1]),
              callback: function(value, index) {
                if (component.plotUnit === 'month') {
                  if (value.indexOf('T') > 0) {
                    return moment(value).format('MMMM');
                  }
                }
                if (component.plotUnit === 'day') {
                  let temp = value.split(' ');
                  return temp[0];
                }
                return value;
              }
            }
          }
        ]
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/commons/charts/chartsHelpers.js